import { render, staticRenderFns } from "./Appearance.vue?vue&type=template&id=33f04b94&scoped=true&"
import script from "./Appearance.vue?vue&type=script&lang=ts&"
export * from "./Appearance.vue?vue&type=script&lang=ts&"
import style0 from "./Appearance.vue?vue&type=style&index=0&id=33f04b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f04b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VContainer,VDivider,VRadio,VRadioGroup,VRow,VSlider,VSwitch})
